'use es6';

import get from 'transmute/get';
import { getAdditionalProperties, getObjectName, getObjectType } from '../operators/calleesOperators';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import formatName from 'I18n/utils/formatName';
function findPropertyByName(propertyName, propertiesMap) {
  if (!propertiesMap) {
    return null;
  }
  const property = propertiesMap.get(propertyName);
  return property || null;
}
export function calleeName(calleeObject) {
  const objectType = getObjectType(calleeObject);
  const objectName = getObjectName(calleeObject);
  switch (objectType) {
    case CONTACT:
      {
        const additionalProperties = getAdditionalProperties(calleeObject);
        const firstNameProperty = findPropertyByName('firstname', additionalProperties);
        const lastNameProperty = findPropertyByName('lastname', additionalProperties);
        const emailProperty = findPropertyByName('email', additionalProperties);
        const firstName = get('value', firstNameProperty);
        const lastName = get('value', lastNameProperty);
        const email = get('value', emailProperty);
        return formatName({
          firstName,
          lastName,
          email,
          name: objectName
        });
      }
    default:
      return objectName;
  }
}